class CartGiftWrap extends HTMLElement {
  connectedCallback() {
    const lineKey = this.dataset.removeLine;
    if (!lineKey) return;

    fetch(`${routes.cart_change_url}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0, sections: 'cart-drawer', sections_url: window.location.pathname }),
    })
      .then((response) => response.json())
      .then((state) => {
        if (!this.closest('cart-drawer')) return window.location.reload();
        const source = new DOMParser().parseFromString(state.sections['cart-drawer'], 'text/html').querySelector('#cartDrawerInner');
        document.getElementById('cartDrawerInner').innerHTML = source.innerHTML;
        window.inView();
      })
      .catch((error) => console.error(error));
  }
}

if (!customElements.get('cart-gift-wrap')) {
  customElements.define('cart-gift-wrap', CartGiftWrap);
}
